import React from "react";
import { Modal } from "antd";
import MainButton from "../../../../components/main-button";
import classes from "./save-class-modal.module.scss";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Input from "../../../../components/form-items/input";
import { connect } from "react-redux";
import { compose } from "redux";
import {
  always,
  applySpec,
  defaultTo,
  either,
  mergeLeft,
  pipe,
  prop,
} from "ramda";
import Textarea from "../../../../components/form-items/textarea";
import withLoadData from "./with-load-data";

const schema = yup.object().shape({
  name: yup.string().required(),
});

const SaveClassModal = ({
  visible,
  onSubmit,
  onHide,
  classItem,
  defaultValues,
}) => {
  const {
    control,
    handleSubmit,
    formState: { isSubmitting, isDirty },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });

  return (
    <Modal
      title={classItem ? "Edit Class" : "Create Class"}
      visible={visible}
      onCancel={onHide}
      footer={null}
      className={classes.FormModal}
      width={500}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.Row}>
          <label className={classes.Label}>Name:</label>
          <Input control={control} name="name" />
        </div>
        <div className={classes.Row}>
          <label className={classes.Label}>Description:</label>
          <Textarea control={control} name="description" />
        </div>
        <div className={classes.Footer}>
          <MainButton type="submit" disabled={isSubmitting || !isDirty}>
            Save
          </MainButton>
        </div>
      </form>
    </Modal>
  );
};

const mapStateToProps = (state, props) => {
  const defaultValues = applySpec({
    id: either(prop("class_id"), always(null)),
    name: either(prop("class_name"), always("")),
    description: either(prop("class_description"), always("")),
  })(props.classItem);

  return {
    defaultValues: pipe(
      defaultTo({}),
      mergeLeft(defaultValues)
    )(props.classItem),
  };
};

export default compose(
  withLoadData,
  connect(mapStateToProps, undefined)
)(SaveClassModal);
